module.exports = __webpack_public_path__ + "img/db9c6e8.png";